import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';

export function Home() {
  return (
    <div className="relative overflow-hidden bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="relative z-10 pb-8 sm:pb-16 md:pb-20 lg:w-full lg:pb-28 xl:pb-32">
          <main className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
            <div className="lg:grid lg:grid-cols-2 lg:gap-8 items-center">
              <div className="sm:text-center lg:text-left">
                <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white sm:text-5xl md:text-6xl">
                  <span className="block">Streamline Your</span>
                  <span className="block text-indigo-600 dark:text-indigo-400">Job Applications</span>
                </h1>
                <p className="mt-3 text-base text-gray-500 dark:text-gray-400 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                  Let our expert agents handle your job applications while you focus on what matters most. Fast, efficient, and reliable application processing.
                </p>
                <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                  <div className="rounded-md shadow">
                    <Link
                      to="/register"
                      className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600 md:py-4 md:text-lg md:px-10"
                    >
                      Get Started
                      <ArrowRight className="ml-2 h-5 w-5" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="mt-12 lg:mt-0 flex justify-center">
                <iframe 
                  width="840" 
                  height="472" 
                  src="https://www.youtube.com/embed/MEzwCBrX6S4?si=hNn8JEg5h_yq_j_W&rel=0" 
                  title="YouTube video player" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  className="rounded-xl shadow-2xl w-full max-w-xl lg:max-w-2xl xl:max-w-3xl"
                ></iframe>
              </div>
            </div>
          </main>
        </div>
      </div>

      <div className="bg-gray-50 dark:bg-gray-800 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:text-center">
            <h2 className="text-base text-indigo-600 dark:text-indigo-400 font-semibold tracking-wide uppercase">Features</h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
              Why Choose BlitzApply?
            </p>
          </div>

          <div className="mt-10">
            <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
              {[
                {
                  title: 'Professional Agents',
                  description: 'Our expert agents handle your applications with care and attention to detail.'
                },
                {
                  title: 'Time Saving',
                  description: 'Focus on preparing for interviews while we handle the paperwork.'
                },
                {
                  title: 'Secure & Private',
                  description: 'Your data is protected with enterprise-grade security measures.'
                },
                {
                  title: 'Credit System',
                  description: 'Flexible credit-based system for managing your application submissions.'
                }
              ].map((feature) => (
                <div key={feature.title} className="relative">
                  <div className="flex items-center space-x-4">
                    <CheckCircle className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
                    <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">{feature.title}</h3>
                  </div>
                  <p className="mt-2 ml-10 text-base text-gray-500 dark:text-gray-400">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}